export default __webpack_public_path__ + "static/media/local_celebrations.489303b0.svg";